import { RootModule } from '@uirouter/angular';
import { states } from './preview-routing.states';

export const config: RootModule = {
  states: states,
  // otherwise: {state: 'common.preview.landing'},
  // initial: {state: 'common.preview.landing'},
  useHash: false,
};
